import {AbstractVisualFeature} from '#core/application/modules/visual-feature.js';

import {SportsContent} from '../sports-content.js';

import {tableLeaguePageFactory} from './table-league-page.factory.js';

import PALETTE_SCHEMA from './table-league-page.palette-schema.yaml';

class TableLeaguePageFeature extends AbstractVisualFeature {
    get name() {
        return 'TableLeague Page';
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    getSerializableVisualConfig(PALETTE) {
        return tableLeaguePageFactory(PALETTE);
    }
}

export const TableLeaguePage = new TableLeaguePageFeature(SportsContent);
